import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Axios from 'axios';
//import clsx from 'clsx';
//import { Button } from '@material-ui/core';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import {
  Container,
  Grid,
  makeStyles
} from '@material-ui/core';
import MuiAlert from '@material-ui/lab/Alert';
import Snackbar from '@material-ui/core/Snackbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Page from '../../../../../src/components/Page';
import PendingClients from './PendingClients';
import BarChart from './FormBarChart';
import RejectedClients from './RejectedClients';
import ApprovedClients from './ApprovedClients';
import TotalForms from './TotalForms';
import FormPieChart from './FormPieChart';
//import { SearchInput } from '../../../../components/';

function Alert(props) {
  return <MuiAlert elevation={0} variant="filled" {...props} />;
}

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  row: {
    height: '42px',
    display: 'flex',
    alignItems: 'center',
    marginTop: theme.spacing(1)
  },
  spacer: {
    flexGrow: 1
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
  importButton: {
    marginRight: theme.spacing(1)
  },
  exportButton: {
    marginRight: theme.spacing(1)
  },
  searchInput: {
    marginRight: theme.spacing(1)
  }
}));

export const HomeToolbar = props => {
  //const { className, ...rest } = props;
  const [tableData, setTableData] = useState('');
  const [openSnack, setOpenSnack] = useState(false);
  const [snackOpenError, setSnackOpenError] = useState(false);

  useEffect(() => {
    handleToggleSnackBar();
    fetchData();
    // window.onbeforeunload = confirmExit;
    // function confirmExit()
    // {
    //   return "Please Logout out";
    // }
    //eslint-disable-next-line
  }, []);

  const config = {
    headers: {
      // "signature": process.env.REACT_APP_SIGNATURE,
      "signature": "64cf508d98d5dcb0d35a1e9fb6e4c278f3123b6cf1435036e6b98f4bf8aa86a6",
      "Content-Type": 'application/json;charset=UTF-8',
      "username": "KYCUI-TEST",
      "applicationID": "KYCUI",
      "where": null,
      "action": "VIEW_DETAILS",
      "query": "KYC"
    },
  };

  // const apiUrl = "http://192.72.53.70:5000/we_dont_live_here";
  // const apiUrl = "http://192.72.53.36:9090/KYC/Read";
  // const apiUrl = "https://192.72.53.70/KYC/Read"; 
  const apiUrl = "https://192.72.53.70:5000/api/KYC/Read"; 

  const fetchData = async () => {
    await Axios.get(apiUrl, config).then(res => {
      if (res.data.response_message === "Customer details successfully Retrieved!") {
        setTableData(res.data.response_data);
        handleCloseSnackBar()
      } else {
        handleCloseSnackBar()
        handleOpenSnackError()
      }
    })
      .catch(() => {
        handleCloseSnackBar()
        handleOpenSnackError();
      });
  }
  const handleOpenSnackError = () => {
    setSnackOpenError(true)
  }
  const classes = useStyles();

  const handleCloseSnackError = (e, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackOpenError(false)
  }

  const handleCloseSnackBar = () => {
    setOpenSnack(false);
  };

  const handleToggleSnackBar = () => {
    setOpenSnack(true);
  };

  // const tableDataValue = tableData.length === 0 ? [] : (
  //   JSON.parse(tableData).map(table => {
  //     let dataArray = [table.id, table.formID, table.surname, table.otherNames, table.accountName, table.accountNumber,
  //     table.branch, table.date, table.gender, table.maritalStatus, table.idType, table.dateOfBirth, table.nationality,
  //     table.country, table.cardNumber, table.expiryDate, table.phone, table.otherNumber, table.poBox, table.postalOffice,
  //     table.email, table.city, table.province, table.village, table.zipcode, table.zone, table.sourcesOfIncome, table.othersourcesOfIncome,
  //     table.alternativeSourceOfIncome, table.currentEmployer, table.currentRole, table.workplaceAddress, table.periodWithWorkplace,
  //     table.monthlyGrossIncome, table.signingMandate, table.otherSigningMandate, table.bankNameDeposit, table.depositAccountNames,
  //     table.depositAccountNumber, table.telecomName, table.registeredNames, table.registeredNumber, table.policy, table.status];
  //     return dataArray;
  //   })
  // );

  //lengths
  const totalArray = tableData.length === 0 ? 0 : (JSON.parse(tableData).length)
  const PendingArray = tableData.length === 0 ? 0 : (JSON.parse(tableData).filter(value => value.status === "PENDING").length)
  const ApprovedArray = tableData.length === 0 ? 0 : (JSON.parse(tableData).filter(value => value.status === "APPROVED").length)
  const RejectedArray = tableData.length === 0 ? 0 : (JSON.parse(tableData).filter(value => value.status === "REJECTED").length)
  // percentages
  const PendingArrayPercentage = (PendingArray / totalArray) * 100
  const ApprovedArrayPercentage = (ApprovedArray / totalArray) * 100
  const RejectedArrayPercentage = (RejectedArray / totalArray) * 100
  // const ApprovedArray = JSON.parse(tableData).filter(value => value.status === "APPROVED")
  // const RejectedArray = JSON.parse(tableData).filter(value => value.status === "REJECTED")
  // console.log('ApprovedArray %', ApprovedArrayPercentage)
  // console.log('PendingArray %', PendingArrayPercentage)
  // console.log('RejectedArray %', RejectedArrayPercentage)
  // console.log('totalArray length', totalArray)

  return (

    <Page
      className={classes.root}
      title="Dashboard"
    >
      <Backdrop className={classes.backdrop} open={openSnack}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        open={snackOpenError}
        autoHideDuration={3000}
        onClose={handleCloseSnackError}
        key="topcenter"
        action={
          <React.Fragment>
            <IconButton size="small" aria-label="close" color="inherit" onClick={handleCloseSnackError}>
              <CloseIcon fontSize="small" />
            </IconButton>
          </React.Fragment>
        }
      >
        <Alert onClose={handleCloseSnackError} severity="warning" className={classes.snackFont}>
          Unable to fetch data, Please try again in a few minutes or contact support.
                    </Alert>
      </Snackbar>
      <Container maxWidth={false}>
        <Grid
          container
          spacing={3}
        >
          <Grid
            item
            lg={3}
            sm={6}
            xl={3}
            xs={12}
          >
            <PendingClients
              PendingArray={PendingArray}
              PendingArrayPercentage={PendingArrayPercentage}
              totalArray={totalArray}
            />
          </Grid>
          <Grid
            item
            lg={3}
            sm={6}
            xl={3}
            xs={12}
          >
            <ApprovedClients
              ApprovedArray={ApprovedArray}
              ApprovedArrayPercentage={ApprovedArrayPercentage}
              totalArray={totalArray}
            />
          </Grid>
          <Grid
            item
            lg={3}
            sm={6}
            xl={3}
            xs={12}
          >
            <RejectedClients
              RejectedArray={RejectedArray}
              RejectedArrayPercentage={RejectedArrayPercentage}
              totalArray={totalArray}
            />
          </Grid>
          <Grid
            item
            lg={3}
            sm={6}
            xl={3}
            xs={12}
          >
            <TotalForms totalArray={totalArray} />
          </Grid>
          <Grid
            item
            lg={8}
            md={12}
            xl={9}
            xs={12}
          >
            <BarChart
              totalArray={totalArray}
              PendingArray={PendingArray}
              RejectedArray={RejectedArray}
              ApprovedArray={ApprovedArray}
            />
          </Grid>
          <Grid
            item
            lg={4}
            md={6}
            xl={3}
            xs={12}
          >
            <FormPieChart
              ApprovedArrayPercentage={ApprovedArrayPercentage}
              RejectedArrayPercentage={RejectedArrayPercentage}
              PendingArrayPercentage={PendingArrayPercentage}
              totalArray={totalArray}
            />
          </Grid>
        </Grid>
      </Container>
    </Page>
  );
};

HomeToolbar.propTypes = {
  className: PropTypes.string
};

export default HomeToolbar;
